import React, { useEffect } from "react";
import MasterComponent from "../../../../components/Forms";
import { FormColumnConfig, MasterConfigs } from "../../../../interfaces/entity";
import { Button } from "antd";
import CustomModal from "../../../../components/custom/Modal";
import FormBuilder from "./Form";
import { useDispatch } from "react-redux";
import { putData } from "../../../../actions/developer";
import FormSetup from "../../../../components/Forms/FormSetup";
import { getFuncParseValue } from "../../../../constants/functions";
const Forms: React.FC<any> = () => {
    const [open, setOpen] = React.useState<boolean>(false);
    const [value, setValue] = React.useState<any>(null);
    const [formValue, setFormValue] = React.useState<any>(null);
    const [form, setForm] = React.useState<any>(null);
    const [formId, setFormId] = React.useState<string>(null);
    const [combo, setCombo] = React.useState<any[]>([]);

    const dispatch = useDispatch();

    const onClose = () => {
        setOpen(false);
        setFormId(null);
        setFormValue(null);
        setValue(null);
    }


    const onSubmitForm = async () => {
        try {
            const resData = await dispatch(putData(`/form-configs/${formId}`, { fields: value, combo: combo }));
            if (resData) {
                setOpen(false);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const formConfig: MasterConfigs = {
        api: () => `/form-configs`,
        modalTitle: (action: string) => `${action} Form`,
        isActionTab: true,
        getColumns: () => {
            return [
                {
                    title: "Form Name",
                    dataIndex: "name",
                    key: "name",
                    width: 250
                },
                {
                    title: "Category",
                    dataIndex: "category",
                    key: "category",
                    render: (text) => text?.name,
                    width: 250
                },
                {
                    title: "Route Name",
                    dataIndex: "routeName",
                    key: "routeName",
                },
                {
                    title: "Model Title",
                    dataIndex: "modelTitle",
                    key: "modelTitle",
                },
                {
                    title: "Required",
                    dataIndex: "required",
                    key: "required",
                    align: "center",
                },
                {
                    title: "Add More",
                    dataIndex: "addMore",
                    key: "addMore",
                    align: "center",
                },
                {
                    title: "Priview",
                    dataIndex: "",
                    key: "",
                    align: "center",
                    width: 100,
                    render: (text, record) => <Button type="link" onClick={() => {
                        setForm(text);
                        setOpen(true)
                    }}>View</Button>
                },
                {
                    title: "Form",
                    dataIndex: "",
                    key: "",
                    align: "center",
                    width: 100,
                    render: (text, record) => <Button type="link" onClick={() => {
                        setFormValue(text.fields);
                        setFormId(record._id);
                        setOpen(true)
                    }}>{text.fields.lentgh > 0 ? 'Edit Form' : 'Add Form'}</Button>
                }
            ]
        },
        getFormColumns: () => {
            return [
                {
                    name: "name",
                    label: "Form Name",
                    type: "text",
                    rules: [{ required: true, message: "Please enter category name" }],
                },
                {
                    name: "category",
                    label: "Category Name",
                    type: "select",
                    rules: [{ required: true, message: "Please select category name" }],
                    isCombo: true,
                },
                {
                    name: "routeName",
                    label: "Route Name",
                    type: "text"
                },
                {
                    name: "modelTitle",
                    label: "Model Title",
                    type: "text"
                },
                {
                    name: "required",
                    label: "Is Required",
                    type: "select",
                    rules: [{ required: true, message: "Please select Required or Optional" }],
                    children: [
                        {
                            name: "Required",
                            value: 'Yes'
                        },
                        {
                            name: "Optional",
                            value: 'No'
                        }
                    ]
                },
                {
                    name: "addMore",
                    label: "Add More",
                    type: "select",
                    rules: [{ required: true, message: "Please select add more" }],
                    children: [
                        {
                            name: "Yes",
                            value: 'Yes'
                        },
                        {
                            name: "No",
                            value: 'No'
                        }
                    ]
                },
                {
                    name: "description",
                    label: "Description",
                    type: "textarea",
                },
            ]
        },
        actions: [
            {
                name: "Add",
                actionType: "Add",
                settings: {
                    type: "primary"
                }
            }
        ],
        combo: [
            {
                name: "category",
                api: "/form-category",
                idKey: "_id",
                render: (e) => e.name
            }
        ]
    }

    return <>
        <MasterComponent config={formConfig} />
        {!formId && <FormSetup config={{
            api: () => form?.routeName,
            modalTitle: (action: string) => `${action} ${form?.modelTitle}`,
            getFormColumns: () => form?.fields.map(ele => ({
                ...ele,
                formItem: ele.type === "custom" ? getFuncParseValue(ele?.rawData) : ele?.formItem
            })) ?? []
        } as MasterConfigs}
            open={open}
            onClose={onClose}
            isModal={true}
        />}
        {formId && <CustomModal
            open={open}
            title="Form Builder"
            onClose={() => onClose()}
            footer={[
                <Button
                    key="back"
                    onClick={() => onClose()}
                    className="mr-2"
                >
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={() => onSubmitForm()}
                >
                    Submit
                </Button>
            ]}
        >
            <FormBuilder onFormValueChange={(e) => setValue(e)} formValue={formValue} onComboSet={(e) => setCombo(e)} />
        </CustomModal>}
    </>
}

export default Forms;